var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Client {
    constructor(serverURL, middlewares) {
        this.serverURL = serverURL;
        this.middlewares = middlewares;
    }
    sendGetRequest(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.serverURL}${path}`;
            return yield this.sendRequest(url, { method: 'GET' });
        });
    }
    sendPutRequest(path, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.serverURL}${path}`;
            return yield this.sendRequest(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
        });
    }
    sendPostRequest(path_1) {
        return __awaiter(this, arguments, void 0, function* (path, data = null) {
            const url = `${this.serverURL}${path}`;
            if (data !== null) {
                return yield this.sendRequest(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });
            }
            else {
                return yield this.sendRequest(url, {
                    method: 'POST'
                });
            }
        });
    }
    sendDeleteRequest(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.serverURL}${path}`;
            return yield this.sendRequest(url, {
                method: 'DELETE'
            });
        });
    }
    sendPatchRequest(path, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.serverURL}${path}`;
            return yield this.sendRequest(url, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
        });
    }
    sendRequest(input, init) {
        return __awaiter(this, void 0, void 0, function* () {
            let remainingMiddlewares = [...this.middlewares];
            const next = (input, init) => __awaiter(this, void 0, void 0, function* () {
                if (remainingMiddlewares.length === 0) {
                    return yield fetch(new Request(input, init));
                }
                const [middleware] = remainingMiddlewares.splice(0, 1);
                return yield middleware(input, init !== null && init !== void 0 ? init : {}, next);
            });
            return yield next(input, init);
        });
    }
}
